import { useEffect, useState } from 'react'

const STORAGE_KEY = 'codigo-cortisol-deadline'

interface Countdown {
  hours: string
  minutes: string
  seconds: string
  expired: boolean
}

/** Cuenta regresiva de N horas, persistida por sesión del visitante. */
export function useCountdown(hoursFromNow = 12): Countdown {
  const [deadline] = useState<number>(() => {
    if (typeof window === 'undefined') return Date.now() + hoursFromNow * 3600_000
    const stored = window.sessionStorage.getItem(STORAGE_KEY)
    if (stored) {
      const parsed = Number(stored)
      if (!Number.isNaN(parsed) && parsed > Date.now()) return parsed
    }
    const next = Date.now() + hoursFromNow * 3600_000
    window.sessionStorage.setItem(STORAGE_KEY, String(next))
    return next
  })

  const [remaining, setRemaining] = useState(() => Math.max(0, deadline - Date.now()))

  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(Math.max(0, deadline - Date.now()))
    }, 1000)
    return () => window.clearInterval(id)
  }, [deadline])

  const totalSeconds = Math.floor(remaining / 1000)
  const pad = (n: number) => String(n).padStart(2, '0')

  return {
    hours: pad(Math.floor(totalSeconds / 3600)),
    minutes: pad(Math.floor((totalSeconds % 3600) / 60)),
    seconds: pad(totalSeconds % 60),
    expired: remaining <= 0,
  }
}
